"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtkAdminIdentityService = void 0;
var rest_service_1 = require("./rest.service");
var enums_1 = require("../shared/enums");
var OtkAdminIdentityService = /** @class */ (function (_super) {
    __extends(OtkAdminIdentityService, _super);
    function OtkAdminIdentityService(serviceProps) {
        var _this = _super.call(this, {
            serviceName: enums_1.ServicesEnum.OTK_IDENTITY,
            baseURL: serviceProps.configService.config.otkIdentityServiceUrl,
            authService: serviceProps.adminAuthService,
        }) || this;
        _this.adminPrefix = 'admin/';
        _this.teacherSearchPath = _this.adminPrefix + 'teachers';
        _this.schoolUsersPath = _this.adminPrefix + 'schools/:schoolUUID/users';
        _this.launchPath = _this.adminPrefix + 'launch';
        _this.passwordResetEmailPath = _this.adminPrefix + 'password';
        _this.usersPath = _this.adminPrefix + 'users';
        _this.legacyRedeemLaunchPath = 'launches/:launchId';
        return _this;
    }
    OtkAdminIdentityService.prototype.searchTeachers = function (brand, queryString) {
        return __awaiter(this, void 0, void 0, function () {
            var response, rejectReason_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.search(this.teacherSearchPath, {
                                brand: brand,
                                q: queryString,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        rejectReason_1 = _a.sent();
                        throw new Error('Unable to search teachers -> ' + rejectReason_1);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OtkAdminIdentityService.prototype.getSchoolUsers = function (schoolUUID) {
        return __awaiter(this, void 0, void 0, function () {
            var schoolId, response, rejectReason_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        schoolId = schoolUUID;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.request(this.schoolUsersPath.replace(':schoolUUID', schoolId))];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 3:
                        rejectReason_2 = _a.sent();
                        throw new Error("Unable to get users from school '".concat(schoolId, "' -> ") + rejectReason_2);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    OtkAdminIdentityService.prototype.createLaunch = function (userId, schoolId, role, brand) {
        return __awaiter(this, void 0, void 0, function () {
            var response, rejectReason_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.update(this.launchPath, {
                                userId: userId,
                                schoolId: schoolId,
                                role: role,
                            }, undefined, undefined, { brand: brand })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        rejectReason_3 = _a.sent();
                        throw new Error('Error while creating a new launch id for an admin -> ' + rejectReason_3);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OtkAdminIdentityService.prototype.sendPasswordResetEmail = function (email, brand) {
        return __awaiter(this, void 0, void 0, function () {
            var rejectReason_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request(this.passwordResetEmailPath, enums_1.RequestMethodEnum.PUT, {
                                email: email,
                                brand: brand,
                            }, null, true, {
                                Accept: '*/*',
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        rejectReason_4 = _a.sent();
                        throw new Error('Unable to reach the service -> ' + rejectReason_4);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OtkAdminIdentityService.prototype.fetchLegacyLmsLaunchLocation = function (legacyLmsUrl, user) {
        return __awaiter(this, void 0, void 0, function () {
            var launchData, rejectReason_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.createLaunch(user.guid, user.schoolGuid, user.role, user.brand)];
                    case 1:
                        launchData = _a.sent();
                        return [2 /*return*/, legacyLmsUrl + '/' + this.legacyRedeemLaunchPath.replace(':launchId', launchData.id)];
                    case 2:
                        rejectReason_5 = _a.sent();
                        throw new Error('Unable to fetch Legacy LMS launch location for an admin -> ' + rejectReason_5);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OtkAdminIdentityService.prototype.updateUser = function (updatedUser) {
        return __awaiter(this, void 0, void 0, function () {
            var response, rejectReason_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request(this.usersPath, enums_1.RequestMethodEnum.PUT, updatedUser)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        rejectReason_6 = _a.sent();
                        throw new Error('Unable to update user -> ' + rejectReason_6);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OtkAdminIdentityService.prototype.updateUserDetails = function (originalUser, editValues) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedUser;
            return __generator(this, function (_a) {
                updatedUser = __assign({}, originalUser);
                editValues.username && (updatedUser.username = editValues.username);
                editValues.email && (updatedUser.email = editValues.email);
                editValues.firstName && (updatedUser.firstName = editValues.firstName);
                editValues.lastName && (updatedUser.lastName = editValues.lastName);
                return [2 /*return*/, this.updateUser(updatedUser)];
            });
        });
    };
    OtkAdminIdentityService.prototype.updateUserActive = function (originalUser, active) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedUser;
            return __generator(this, function (_a) {
                updatedUser = __assign(__assign({}, originalUser), { active: active });
                return [2 /*return*/, this.updateUser(updatedUser)];
            });
        });
    };
    return OtkAdminIdentityService;
}(rest_service_1.RestService));
exports.OtkAdminIdentityService = OtkAdminIdentityService;
